import React, { useCallback } from 'react';

import { InviteErrorFlag } from '@atlassian/invite-prompt/invite-error-flag/main';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const useInviteErrorFlag = (flags?: FlagsStateContainer): (() => void) => {
	return useCallback(() => {
		const dismiss = (id: string | number) => flags?.hideFlag(id);

		flags?.showFlag({
			customComponent: (props) => <InviteErrorFlag {...props} id={props.id} onDismiss={dismiss} />,
		});
	}, [flags]);
};
